import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMemberKey, getMembersKey } from '../../utils/keys';
export const useUnsuspendMember = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(variables => client.mutation({
        name: 'unsuspendMember',
        args: {
            fields: 'basic',
            variables,
        },
    }), {
        onSettled: (data, error, variables) => {
            const memberKey = getMemberKey({
                variables: { id: variables === null || variables === void 0 ? void 0 : variables.memberId },
            });
            queryClient.invalidateQueries(memberKey);
            const membersKey = getMembersKey();
            queryClient.invalidateQueries(membersKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUnsuspendMember.js.map